<template>
    <Modal :show="modalOpen" :closable="!isLoading" @close="close">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('ceremony.send_invite') }}</h5>
                <button
                    type="button"
                    class="close"
                    @click="close"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body">
            {{ $t('ceremony.send_invitation_message', {
                type: ceremony.translated_type.toLowerCase(),
                name: ceremony.name,
                emails: ceremony.attendee.email,
            }) }}
        </div>

        <div slot="footer">
            <button type="button" :disabled="isLoading" class="btn btn-success btn-icon btn-sm" @click="sendInvite">
                <icon name="envelope" scale="0.8"></icon>
                {{ $t('general.send') }}
            </button>

            <button type="button" :disabled="isLoading" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="close">
                {{ $t('general.close') }}
            </button>
        </div>
    </Modal>
</template>

<script setup>
    import Modal from '../../components/Modal.vue';
    import { ref } from 'vue';
    import { ipcCall, IpcCall } from '../utils/ipcCall';
    import i18n from "../../utils/locale";
    import { notifyError, notifySuccess } from '../../utils/notify';

    const emit = defineEmits(['close', 'sent']);
    const props = defineProps({
        ceremony: {
            type: Object,
            required: true,
        },
    });

    const isLoading = ref(false);
    const modalOpen = ref(true);

    async function sendInvite() {
        isLoading.value = true;

        try {
            await ipcCall(IpcCall.SendCeremonyInvite, {
                ceremonyId: props.ceremony.id,
            });

            emit('sent');
            notifySuccess(i18n.t('ceremony.sent_invitation'))
        } catch (exception) {
            if (!exception.response || (exception.response && exception.response.status !== 401)) {
                notifyError(exception, i18n.t('ceremony.cant_send_invitation'));
            }
        } finally {
            isLoading.value = false;
        }
    }

    function close() {
        emit('close');
    }
</script>
